export default [
  {
    path: '/subjects',
    icon: 'folder',
    label: 'Subjects Library'
  },
  {
    path: '/lessons',
    icon: 'menu',
    label: 'Lessons'
  },
  {
    path: '/levels',
    icon: 'ruler-pencil',
    label: 'Game Levels'
  },
  {
    path: '/elements',
    icon: 'receipt',
    label: 'Elements Library'
  },
  {
    path: '/students',
    icon: 'user',
    label: 'Students Catalog'
  },
  {
    path: '/statistic',
    icon: 'bar-chart-alt',
    label: 'Games Statistic'
  }
]



// WEBPACK FOOTER //
// ./src/modules/Dashboard/Constants/NavigationItems.js